// extracted by mini-css-extract-plugin
module.exports = {"WomanList":"styles_WomanList__1vchk","WomanList-items":"styles_WomanList-items__1QiaI","WomanList-feedback":"styles_WomanList-feedback__1IKUR"};